import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsEnhancedTripResponse } from "../../Orchestrator/Types/Interface/ICmsEnhancedTrip";

export async function getCmsEnahancedTripDetailBySlug(
  slug: string
): Promise<IApiResponse<ICmsEnhancedTripResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getEnhanceYourTripAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("filters[slug][$eq]", slug);
  params.append("populate", "image");
  params.append("populate", "full");
  params.append("locale", locale);

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsEnhancedTripResponse>(
    endpointWithParams,
    "GET"
  );
}
